module.exports = __webpack_public_path__ + "img/hanging tree-Valera-Lutfullina.774f2b0c.jpg";